import { SensorList } from '@/types/sensor'

export const initialState: SoilMoistureDashboardState = {
  isLoadingSensors: false,
  sensors: undefined,
}

export interface SoilMoistureDashboardState {
  isLoadingSensors: boolean
  sensors?: SensorList[]
}
